import { fetch } from "owa-fetch";
import { getApplicationSettings } from "owa-application-settings";
import { lazyFetchCloudAwareOcpsPolicies } from "../lazyFunctions";
import { isAccountFeatureEnabled } from "owa-feature-flags";
import getOcpsTokenForBusiness from "./getOcpsTokenForBusiness";
import { buildAuthorizationHeader } from "owa-tokenprovider-utils";
import type { MailboxInfo } from "owa-client-types";
import { getCallerAppHint } from "../utils/getCallerAppHint";

export default async function getBusinessUserOcpsPolicies(mailboxInfo: MailboxInfo, correlationId: string): Promise<Response> {
    const headers = new Headers();
    headers.append("Content-Type", "application/json; charset=utf-8");
    headers.append("x-Cid", correlationId);
    headers.append("CallerAppHint", getCallerAppHint());
    
    const requestInit: RequestInit = {
        method: "GET",
    };
    
    requestInit.headers = headers;
    
    if (isAccountFeatureEnabled("cloudAwareFetch-ocps", mailboxInfo)) {
        const fetchCloudAwareOcpsPolicies = await lazyFetchCloudAwareOcpsPolicies.import();
        return fetchCloudAwareOcpsPolicies(requestInit, mailboxInfo);
    }
    else {
        const ocpsPolicyConfig = getApplicationSettings("OcpsPolicyStore", mailboxInfo);
        const token = await getOcpsTokenForBusiness(ocpsPolicyConfig.tokenResourceUrl, mailboxInfo);
        headers.append("Authorization", buildAuthorizationHeader(token as string));
        
        return fetch(ocpsPolicyConfig.getOcpsPoliciesEndpoint, requestInit);
    }
}
